import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import { PaymentMethod, PaymentMethodType } from '@/modules/employee/employee.types';
import { AllowedPaymentMethodConfig } from '@/modules/employer/types';

import PaymentMethodDescription from './PaymentMethodDescription';
import PaymentMethodIcon from './PaymentMethodIcon';
interface Props {
  isVerifiedDateVisible?: boolean;
  paymentMethod?: Partial<PaymentMethod>;
  simplifyDesc?: boolean;
  hideIconBorder?: boolean;
  hasPaymentFreeTimeLabel?: boolean;
  hideNonDebitIcons?: boolean;
  allowedPaymentMethodConfigs?: AllowedPaymentMethodConfig[];
}

export const PaymentMethodLabel: React.FC<Props> = ({
  paymentMethod,
  simplifyDesc,
  hideIconBorder,
  isVerifiedDateVisible = true,
  hasPaymentFreeTimeLabel = true,
  hideNonDebitIcons,
  allowedPaymentMethodConfigs,
}) => {
  const paymentEmployeeFee = useMemo(() => allowedPaymentMethodConfigs
    ?.find((item) => item?.paymentMethodType === paymentMethod?.type)?.paymentEmployeeFee,
  [paymentMethod, allowedPaymentMethodConfigs]);
  const shouldShowIcon = useMemo(
    () => !hideNonDebitIcons || (paymentMethod?.type === PaymentMethodType.DEBIT),
    [hideNonDebitIcons, paymentMethod]);
  return (
    <Box
      data-testid="PaymentMethodLabel_container"
      direction="row"
      align="center"
    >
      {shouldShowIcon &&
        <PaymentMethodIcon paymentMethod={paymentMethod} hideIconBorder={hideIconBorder} />}
      <PaymentMethodDescription
        hasPaymentFreeTimeLabel={hasPaymentFreeTimeLabel}
        paymentMethod={paymentMethod}
        simplifyDesc={simplifyDesc}
        isVerifiedDateVisible={isVerifiedDateVisible}
        paymentEmployeeFee={paymentEmployeeFee}
        hasPaymentEmployeeFeeLabel={Boolean(allowedPaymentMethodConfigs)}
      />
    </Box>
  );
};
